export class HrPerEvaluationRuleDefinitionKey {
    private static readonly keyPrefix = 'hrPerEvaluationRuleDef';
    public static title = `${HrPerEvaluationRuleDefinitionKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerEvaluationRuleDefinitionKey.keyPrefix}.pageHeader`;
    public static perCriteriaType = `${HrPerEvaluationRuleDefinitionKey.keyPrefix}.perCriteriaType`;
    public static objectNumber = `${HrPerEvaluationRuleDefinitionKey.keyPrefix}.objectNumber`;
    public static beginDate = `${HrPerEvaluationRuleDefinitionKey.keyPrefix}.beginDate`;
    public static endDate = `${HrPerEvaluationRuleDefinitionKey.keyPrefix}.endDate`;
    public static status = `${HrPerEvaluationRuleDefinitionKey.keyPrefix}.status`;
    public static shortText = `${HrPerEvaluationRuleDefinitionKey.keyPrefix}.shortText`;
    public static longText = `${HrPerEvaluationRuleDefinitionKey.keyPrefix}.longText`;
    public static perCriteriaRule = `${HrPerEvaluationRuleDefinitionKey.keyPrefix}.perCriteriaRule`;
    public static perEvaluationType = `${HrPerEvaluationRuleDefinitionKey.keyPrefix}.perEvaluationType`;
    public static criteriaSelectionTitle = `${HrPerEvaluationRuleDefinitionKey.keyPrefix}.criteriaSelectionTitle`;
    public static criteriaRuleTypeId = `${HrPerEvaluationRuleDefinitionKey.keyPrefix}.criteriaRuleTypeId`;
    public static method = `${HrPerEvaluationRuleDefinitionKey.keyPrefix}.method`;
    public static perCriteriaRuleType = `${HrPerEvaluationRuleDefinitionKey.keyPrefix}.perCriteriaRuleType`;
    public static methodList = `${HrPerEvaluationRuleDefinitionKey.keyPrefix}.methodList`;
}
